export enum LocaleKey {
  en = 'en',
  it = 'it',
  hy = 'hy',
  ru = 'ru',
  pt = 'pt',
  es = 'es',
  de = 'de',
  fr = 'fr',
  br = 'br',
}

export const localeNames = {
  [LocaleKey.en]: 'English',
  [LocaleKey.it]: 'Italiano',
  [LocaleKey.hy]: 'Հայերեն',
  [LocaleKey.ru]: 'Русский',
  [LocaleKey.pt]: 'Português',
  [LocaleKey.es]: 'Español',
  [LocaleKey.de]: 'Deutsch',
  [LocaleKey.fr]: 'Français',
  [LocaleKey.br]: 'Brazil',
};
